(() => {
    const banner = document.querySelector<HTMLElement>(".attention-banner-block");
    if (!banner) return;

    const updateBannerHeight = (): void => {
        document.documentElement.style.setProperty(
            "--attention-banner-height",
            `${banner.offsetHeight}px`
        );
    };

    updateBannerHeight();

    const resizeObserver = new ResizeObserver(updateBannerHeight);
    resizeObserver.observe(banner);
})();
